import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './state'

Vue.config.productionTip = false

const app = new Vue({
  // el: '#cathea',
  router,
  store,
  render: h => h(App)
})

// Initilaize store before mounting
app.$store.dispatch('init')
  .then(() => app.$mount('#cathea'))
